/** Corptax catalog event names used by this app's analytics hooks. */
export const ACTION_INVOKED_EVENT = 'action_invoked';

/** Alias for UTM redirect landing events (same wire name as ACTION_INVOKED_EVENT). */
export const REDIRECTED_EVENT_NAME = ACTION_INVOKED_EVENT;

/** Fixed `action_name` property values for `action_invoked`. */
export const REDIRECTED_ACTION_NAME = 'redirected_to_calc_review';
export const PRINT_REPORT_MODAL_CLOSED = 'print_report_modal_closed';
export const JOURNAL_ENTRY_DIALOG_CLOSED = 'journal_entry_dialog_closed';
export const ENTER_AMOUNTS_DIALOG_CLOSED = 'enter_amounts_dialog_closed';
export const REPORT_DRILLDOWN_CLOSED = 'report_drilldown_closed';
